import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { getRandomPromoTrips, type PromoTripWithMap } from "../../api/admin";
import { PromoCard } from "./ExamplesSection";

export function TaggedExamples({ tag, limit = 4 }: { tag: string; limit?: number }) {
  const { t } = useTranslation("trips");
  const [trips, setTrips] = useState<PromoTripWithMap[] | null>(null);

  const fetchTrips = useCallback(async () => {
    try {
      const result = await getRandomPromoTrips(limit, tag);
      setTrips(result);
    } catch {
      setTrips([]);
    }
  }, [tag, limit]);

  useEffect(() => {
    fetchTrips();
  }, [fetchTrips]);

  if (trips === null) {
    return (
      <div className="tagged-examples" data-testid="tagged-examples-loading">
        <Spin />
      </div>
    );
  }

  if (trips.length === 0) {
    return (
      <div className="tagged-examples" data-testid="tagged-examples-empty">
        <p>{t("examples.noTaggedTrips", "No example trips found for this category.")}</p>
      </div>
    );
  }

  return (
    <div className="tagged-examples" data-testid="tagged-examples">
      <div className="home-examples__grid">
        {trips.map((trip) => (
          <PromoCard key={trip.tokenId} trip={trip} />
        ))}
      </div>
    </div>
  );
}
